import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useExportDataBl } from '../../ExportData.bl';
import { IExportDataStore } from '../../ExportData.store';
import { ExportButton } from './ExportButton';

export const ExportButtonContainer = observer((): ReactElement => {
  const bl = useExportDataBl();
  const store = useInjection(IExportDataStore.$);

  const handleClick = async (): Promise<void> => {
    if (await bl.isCurrentExportGeneratedAsync()) {
      bl.showDownloadModal(store.latestExportId, store.selectedDataFilter);
      return;
    }

    await bl.exportProjectAsync();
  };

  return (
    <ExportButton
      onClick={handleClick}
      disabled={store.isCurrentlyGenerating}
    />
  );
});
